import * as React from 'react';
import CoreHead, { Props } from '@websky/core/src/Head';

const GOOGLE_FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Geologica:wght@100..900&display=swap';

const Head: React.FC<Props> = ({ children, ...props }) => (
	<CoreHead {...props}>
		<link rel="preconnect" href="https://fonts.googleapis.com" />
		<link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
		<link rel="stylesheet" href={GOOGLE_FONTS_HREF} />
		{children}
	</CoreHead>
);

export default Head;
